import { render, staticRenderFns } from "./BillReciept.vue?vue&type=template&id=0816b192&scoped=true"
import script from "./BillReciept.vue?vue&type=script&lang=js"
export * from "./BillReciept.vue?vue&type=script&lang=js"
import style0 from "./BillReciept.vue?vue&type=style&index=0&id=0816b192&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0816b192",
  null
  
)

export default component.exports